import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-home-map',
  templateUrl: './home-map.component.html',
  styleUrls: ['./home-map.component.scss']
})
export class HomeMapComponent implements OnInit {
  ngOnInit(): void {
  }  
}